import { defineMessages } from 'react-intl';

export default defineMessages({
  actionDelete: {
    id: 'frontbucket.branches.actionDelete',
    description: 'Text for the delete branch action in a git repository',
    defaultMessage: 'Delete',
  },
  deleteDisabledPermissions: {
    id: 'frontbucket.branches.deleteDisabledPermissions',
    description:
      'Text for the tooltip shown when the delete branch action for a git repository is hovered and deletion is disabled due to permissions',
    defaultMessage: 'Branch deletion is disabled for this branch.',
  },
  deleteDisabledMainBranch: {
    id: 'frontbucket.branches.deleteDisabledMainBranch.',
    description:
      'Text for the tooltip shown when the delete branch action for a git repository is hovered and the branch is the main branch',
    defaultMessage: 'The main branch cannot be deleted.',
  },
  branchActionsButtonLabel: {
    id: 'frontbucket.branches.branchActionsButtonLabel',
    description:
      'Label for the button whichs open the Branch Actions dropdown menu',
    defaultMessage: 'Branch actions',
  },
  actionCreatePullRequest: {
    id: 'frontbucket.branches.actionCreatePullRequest',
    description:
      'Text for the create pull request action in the branch row dropdown menu',
    defaultMessage: 'Create pull request',
  },
  actionViewPullRequest: {
    id: 'frontbucket.branches.actionViewPullRequest',
    description:
      'Text for the view pull request action in the branch row dropdown menu',
    defaultMessage: 'View pull request',
  },
  actionViewSource: {
    id: 'frontbucket.branches.actionViewSource',
    description:
      'Text for the view source action in the branch row dropdown menu',
    defaultMessage: 'View source',
  },
  actionCompare: {
    id: 'frontbucket.branches.actionCompare',
    description: 'Text for the compare action in the branch row dropdown menu',
    defaultMessage: 'Compare',
  },
  actionMerge: {
    id: 'frontbucket.branches.actionMerge',
    description: 'Text for the merge action in the branch row dropdown menu',
    defaultMessage: 'Merge',
  },
  actionSync: {
    id: 'frontbucket.branches.actionSync',
    description:
      'Text for the synchronize action in the branch row dropdown menu',
    defaultMessage: 'Sync',
  },
  actionRunPipeline: {
    id: 'frontbucket.branches.actionRunPipeline',
    description:
      'Text for the "run pipeline for a branch" action in the branch row dropdown menu',
    defaultMessage: 'Run pipeline for a branch',
  },
  mergeDisabled: {
    id: 'frontbucket.branches.mergeDisabled',
    description:
      "Text for the tooltip shown when the user doesn't have permission to merge into the main branch",
    defaultMessage:
      'You do not have permission to merge this branch into {destination}',
  },
  syncDisabled: {
    id: 'frontbucket.branches.syncDisabled',
    description:
      "Text for the tooltip shown when the user doesn't have permission to merge the main branch into the branch in the row",
    defaultMessage:
      'You do not have permission to merge {source} into this branch',
  },
  actions: {
    id: 'frontbucket.branches.tableHeaders.actions',
    description: 'Aria-label text for "Actions" button in branch list',
    defaultMessage: 'Actions',
  },
  deleteMultiple: {
    id: 'frontbucket.branches.deleteMultiple',
    description: 'Text for delete multiple branches action',
    defaultMessage: 'Delete multiple...',
  },
  deleteDisabledPullRequests: {
    id: 'frontbucket.branches.deleteDisabledPullRequests.',
    description:
      'Text for the tooltip shown when the delete branch action is disabled because there are pull requests associated with the branch',
    defaultMessage:
      'This branch is the source or destination of an open pull request and cannot be deleted.',
  },
});
